var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 0.90625C5.14505 0.90625 2.6875 3.3638 2.6875 6.375C2.6875 8.2876 3.73763 9.89527 5.23267 10.8733C2.37451 12.036 0.34375 14.8244 0.34375 18.0938H1.90625C1.90625 14.6323 4.69479 11.8438 8.15625 11.8438C11.6177 11.8438 14.4062 14.6323 14.4062 18.0938H15.9688C15.9688 14.8244 13.938 12.036 11.0798 10.8733C12.5749 9.89527 13.625 8.2876 13.625 6.375C13.625 3.3638 11.1674 0.90625 8.15625 0.90625ZM15.1875 0.90625V8.71875H16.75V4.8125H20.6562L18.6528 2.87006L20.6562 0.90625H16.75H15.9688H15.1875ZM8.15625 2.46875C10.3232 2.46875 12.0625 4.20807 12.0625 6.375C12.0625 8.54193 10.3232 10.2812 8.15625 10.2812C5.98932 10.2812 4.25 8.54193 4.25 6.375C4.25 4.20807 5.98932 2.46875 8.15625 2.46875Z",
    fill: "auto"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIcon);
export default __webpack_public_path__ + "static/media/leads-icon.d71bc7a23b5c017077e6dce8c34ca25a.svg";
export { ForwardRef as ReactComponent };